import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { 
  NavController, 
  Events, 
  NavParams, 
  ActionSheetController, 
  ModalController,
  LoadingController
} from 'ionic-angular';

import moment from 'moment';

// Modals
import { IncidentModalPage } from '../../components/modals/incident.modal';
import { CertificationModalPage } from '../../components/modals/certification.modal';
import { EmployerModalPage } from '../../components/modals/employer.modal';
import { CourseModalPage } from '../../components/modals/course.modal';
import { EducationModalPage } from '../../components/modals/education.modal';
import { HelperService } from '../../providers/helpers/helper-service';
import { ProviderInfoModalPage } from '../../components/modals/provider-info.modal';

// Providers
import { InstructorsService } from '../../providers/instructors/instructors-service';
import { RecertificationService } from '../../providers/instructors/recertification-service';
import { ProvidersService } from '../../providers/providers/providers-service';
import { ImageService } from '../../providers/images/image-service';

// Pages
import { RecertificationViewPage } from '../../pages/recertifications/recertification-view'; 

// PDF Make
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

@Component({
  selector: 'page-instructor-add-edit',
  templateUrl: 'instructor-add-edit.html',
  providers: [DatePipe]
})
export class InstructorAddEditPage {
  headerData: any;
  edit: boolean = false;
  instructor: any = {};

  modalIncident: any;
  modalCertification: any;
  modalEmployer: any;
  modalCourse: any;
  modalEducation: any;
  modalProvider: any;
  totalCeHrs: number = 0;
  totalCeHrsSinceRecert: number = 0;
  recertRecord: any;

  isRegistryNumberDisabled: boolean = true; 

  toggle_teach_outside_oregon = false;
  toggle_no_impairment_verify = false;

  dd:any;

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController,
    public instructorsService: InstructorsService,
    public providersService: ProvidersService,
    public helperService: HelperService,
    public datePipe: DatePipe,
    public loadingCtrl: LoadingController,
    public imageService: ImageService,
    public recertificationService: RecertificationService
  ) {
    this.modalIncident = IncidentModalPage;
    this.modalCertification = CertificationModalPage;
    this.modalEmployer = EmployerModalPage;
    this.modalCourse = CourseModalPage;
    this.modalEducation = EducationModalPage;
    this.modalProvider = ProviderInfoModalPage

    if ( this.navParams.get('instructor') )
    {
      this.edit = true;
      this.instructor = this.navParams.get('instructor');
      this.headerData = { title: 'Edit Instructor: ' + this.instructor.first_name + ' ' + this.instructor.last_name };
      this.getInstructorEmployers();

      // Calculate CE Hours      
      for ( let ce of this.instructor.education )
      {
        this.totalCeHrs += ce.number_hours;
      }

      // Calculate CE hours since recertification.
      // certifications could be null in the case of Recertification records.
      console.log(this.instructor.certifications);
      if ( 
        this.instructor.certifications !== null && 
        this.instructor.certifications[0] !== undefined
      )
      {
        const recert_date = this.instructor.certifications[0].date_renewed;
        for ( let e of this.instructor.education )
        {
          if ( moment( e.date_attended ).isSameOrAfter( recert_date ) )
          {
            this.totalCeHrsSinceRecert += e.number_hours;
          }
        }
      }

      // Toggle teach outside Oregon.
      if ( this.instructor.teach_outside_oregon === 'Yes' )
      {
        this.toggle_teach_outside_oregon = true;
      }
      // Toggle no impairment verify.
      if ( this.instructor.no_impairment_verify === 'Yes' )
      {
        this.toggle_no_impairment_verify = true;
      }

      
    } else {
      this.headerData = { title: 'New Instructor' };
      this.instructor.files = [];
    }  
  }

  ngOnInit()
  {
    if ( this.navParams.get('instructor') )
    {
      // See if we have a recertification record for this instructor.
      // Just get the latest record.
      this.recertificationService.getRecertificationByInstructorId( this.instructor.instructor_id )
        .subscribe( data => {
          this.recertRecord = data;
        });
    }
  }

  showRecertificationViewPage( recertification )
  {
    // Get full recertification record.
    this.recertificationService.getRecertification( recertification.recertification_id )
      .subscribe( data => {
        this.navCtrl.push( RecertificationViewPage, {
          recertification: data,
          parentPage: this
        });
      });
  }

  getInstructorEmployers()
  {
    let employers:any = this.instructor.employers;
    for ( let i in employers )
    { 
      employers[i].provider_record = {};
      this.providersService.getProvider( employers[i].provider_id ).subscribe( data => {
        employers[i].provider_record = data;
      });
    }
  }

  saveInstructor()
  {
    // Change dates from MM/DD/YYYY format to MySQL format.
    this.instructor.foundations_course_date = this.datePipe.transform( this.instructor.foundations_course_date, 'yyyy-MM-dd' );
    this.instructor.classroom_course_date = this.datePipe.transform( this.instructor.classroom_course_date, 'yyyy-MM-dd' );
    this.instructor.behind_wheel_course_date = this.datePipe.transform( this.instructor.behind_wheel_course_date, 'yyyy-MM-dd' );
    this.instructor.first_aid_card_expire = this.datePipe.transform( this.instructor.first_aid_card_expire, 'yyyy-MM-dd' );
    this.instructor.cpr_card_expire = this.datePipe.transform( this.instructor.cpr_card_expire, 'yyyy-MM-dd' );
    this.instructor.teaching_time = this.datePipe.transform( this.instructor.teaching_time, 'yyyy-MM-dd' );

    this.instructor.registry_number = +this.instructor.registry_number;

    // Is instructor teaching outside of Oregon?
    if ( this.toggle_teach_outside_oregon === true )
    {
      this.instructor.teach_outside_oregon = 'Yes';
    } else {
      this.instructor.teach_outside_oregon = 'No';
    }

    // Send to service
    this.instructorsService.saveInstructor( this.instructor ).subscribe( data => {
      this.events.publish('app:log', {
        message: 'Instructor information saved.',
        status: 'success',
        type: 'save instructor'
      });

      this.instructor = data;
      this.getInstructorEmployers();
      this.edit = true;
    },
    error => {
      this.helperService.showErrors( error );
    });
    //this.dismissPage();
  }

  deleteInstructor()
  {
    this.instructorsService.deleteInstructor( this.instructor.instructor_id )
    .subscribe( data => {
      this.events.publish('app:log', {
        message: 'Instructor deleted.',
        status: 'warning',
        type: 'delete instructor'
      });
      this.dismissPage();
    },
    error => {
      this.helperService.showErrors( error );
    });
  }

  copyMailingAddress()
  {
    if ( this.instructor.addresses_same === 'Yes' )
    {
      this.instructor.mailing_address = this.instructor.address;
      this.instructor.mailing_city = this.instructor.city;
      this.instructor.mailing_state = this.instructor.state;
      this.instructor.mailing_zip = this.instructor.zip;
    } else {
      this.instructor.mailing_address = '';
      this.instructor.mailing_city = '';
      this.instructor.mailing_state = '';
      this.instructor.mailing_zip = '';
    }
  }

  dismissPage()
  {
    this.navCtrl.pop();
  }

  presentModal( modalType, editData = null, instructor = null, edit = false )
  {
    let instructorsArray = [];
    instructorsArray.push( instructor );
    let modal = this.modalCtrl.create( modalType, {
      editData: editData,
      instructors: instructorsArray,
      edit: edit
    });
    modal.present();
  }

  presentDeleteInstructorActionSheet()
  {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Are you sure you want to delete this instructor?',
      buttons: [
        {
          text: 'Delete instructor',
          role: 'destructive',
          handler: () => {
            this.deleteInstructor();
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {}
        }
      ]
    });

    actionSheet.present();
  }

  presentRemoveActionSheet( itemType, itemId )
  {
    var title = '';
    switch ( itemType )
    {
      case 'education':
        title = 'Are you sure you want to remove this Continuing Education?';
        break;
      case 'course':
        title = 'Are you sure you want to remove this Refresher Course?';
        break;
      case 'certification':
        title = 'Are you sure you want to remove this Certification?';
        break;
      case 'employer':
        title = 'Are you sure you want to remove this Employer?';
        break;
      case 'incident':
        title = 'Are you sure you want to remove this Incident?';
        break;
    }
    
    let actionSheet = this.actionSheetCtrl.create({
      title: title,
      buttons: [
        {
          text: 'Remove ' + itemType,
          role: 'destructive',
          handler: () => {
            this.removeItemFromInstructorRecord( itemType, itemId );
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {}
        }
      ]
    });

    actionSheet.present();
  }

  presentApproveInstructorCandidateActionSheet()
  {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Are you sure you want to approve this Instructor Candidate?',
      buttons: [
        {
          text: 'Yes, approve this candidate.',
          handler: () => {
            this.approveInstructorCandidate();
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {}
        }
      ]
    });

    actionSheet.present();
  }

  // Remove or Delete items from the instructor record.
  removeItemFromInstructorRecord( itemType, itemId )
  {
    switch ( itemType )
    {
      case 'education':
        this.deleteEducation( itemId );
        break;
      case 'course':
        this.deleteCourse( itemId );
        break;
      case 'certification':
        this.deleteCertification( itemId );
        break;
      case 'employer':
        this.deleteEmployer( itemId );
        break;
      case 'incident':
        this.deleteIncident( itemId );
        break;
    }
  }

  deleteEmployer( itemId )
  {
    this.instructorsService.removeProviderFromInstructor( this.instructor.instructor_id, itemId ).subscribe( data => {
      this.events.publish('app:log', {
        message: 'Instructor employer deleted.',
        status: 'warning',
        type: 'delete instructor employer'
      });

      // Remove from instructor object.
      let employers = this.instructor.employers;
      for ( let i in employers )
      {
        if ( employers[i].employer_id === itemId )
        {
          employers.splice(i, 1);
        }
      }
    },
    error => {
      this.helperService.showErrors( error );
    });
  }

  deleteCertification( itemId )
  {
    this.instructorsService.deleteCertification( this.instructor.instructor_id, itemId ).subscribe( data => {
      this.events.publish('app:log', {
        message: 'Instructor certification deleted.',
        status: 'warning',
        type: 'delete instructor certification'
      });

      // Remove from instructor object.
      let certifications = this.instructor.certifications;
      for ( let i in certifications )
      {
        if ( certifications[i].certification_id === itemId )
        {
          certifications.splice(i, 1);
        }
      }
    },
    error => {
      this.helperService.showErrors( error );
    });
  }

  deleteCourse(itemId )
  {
    this.instructorsService.deleteCourse( this.instructor.instructor_id, itemId ).subscribe( data => {
      this.events.publish('app:log', {
        message: 'Instructor course deleted.',
        status: 'warning',
        type: 'delete instructor course'
      });

      // Remove from instructor object.
      let courses = this.instructor.courses;
      for ( let i in courses )
      {
        if ( courses[i].course_id === itemId )
        {
          courses.splice(i, 1);
        }
      }
    },
    error => {
      this.helperService.showErrors( error );
    });
  }

  deleteIncident( itemId )
  {
    this.instructorsService.deleteIncident( this.instructor.instructor_id, itemId ).subscribe( data => {
      this.events.publish('app:log', {
        message: 'Instructor incident deleted.',
        status: 'warning',
        type: 'delete instructor incident'
      });

      // Remove from instructor object.
      let incidents = this.instructor.incidents;
      for ( let i in incidents )
      {
        if ( incidents[i].incident_id === itemId )
        {
          incidents.splice(i, 1);
        }
      }
    },
    error => {
      this.helperService.showErrors( error );
    });
  }

  deleteEducation( itemId )
  {
    this.instructorsService.deleteEducation( this.instructor.instructor_id, itemId ).subscribe( data => {
      this.events.publish('app:log', {
        message: 'Instructor continuing education entry deleted.',
        status: 'warning',
        type: 'delete instructor continuing education'
      });

      // Remove from instructor object.
      let education = this.instructor.education;
      for ( let i in education )
      {
        if ( education[i].education_id === itemId )
        {
          education.splice(i, 1);
        }
      }
    },
    error => {
      this.helperService.showErrors( error );
    });
  }

  approveInstructorCandidate() {
    this.instructorsService.approveInstructorCandidate( this.instructor )
      .subscribe( data => {
        this.instructor = data;
        this.getInstructorEmployers();
        this.events.publish('app:log', {
          message: 'Instructor Candidate has been approved.',
          status: 'success',
          type: 'approve instructor candidate'
        });
      });
  }

  printCertificatePdf()
  {
    // Show loading indicator.
    let loader = this.loadingCtrl.create({
      spinner: 'crescent',
      content: "Generating PDF file..."
    });
    loader.present();

    // Make PDF document definition object.
    var docContent = [];
    var certText = {
      text: 'This certifies that the individual whose name appears below has met the requirements and is approved by the State of Oregon to teach the following Driver Education course(s)', fontSize: 5.7, bold: true, alignment: 'center', margin: [5, 63, 5, 0]
    }

    var name = { 
      text: this.instructor.first_name + ' ' + this.instructor.last_name, bold: true, fontSize: 15, margin: [10, 7, 0, 3]
    }
    var certTypeBtw = {
      text: 'Behind the Wheel', italic: true, fontSize: 10, margin: [15, 0, 0, 0]
    }
    var certTypeClassroom = {
      text: 'Classroom', italic: true, fontSize: 10, margin: [15, 0, 0, 0]
    }
    var certTypeProvisional = {
      text: 'PROVISIONAL', fontSize: 12, bold: true, color: '#DC4048', margin: [15, 0, 0, 0]
    }

    docContent.push( certText );
    docContent.push( name );

    var certExpColsTopMargin = 7;
    if ( this.instructor.provisional === 'Yes' ) 
    {
      docContent.push( certTypeProvisional );
    } 
    if ( this.instructor.behind_the_wheel === 'Yes' )
    {
      docContent.push( certTypeBtw );
    }

    if ( this.instructor.classroom_instructor === 'Yes' )
    {
      docContent.push( certTypeClassroom );
    }

    // Determine top margin of bottom line of text
    // Only Provisional
    if ( 
      this.instructor.provisional === 'Yes' && 
      this.instructor.classroom_instructor !== 'Yes' && 
      this.instructor.behind_the_wheel !== 'Yes' 
    ) {
      certExpColsTopMargin = 16;
    }

    // Provisional AND CR OR BTW (we'll never have both)
    if ( 
      this.instructor.provisional === 'Yes' && 
      (this.instructor.classroom_instructor === 'Yes' ||
      this.instructor.behind_the_wheel === 'Yes')
    ) {
      certExpColsTopMargin = 4;
    }

    // No provisional && either CR OR BTW
    if ( 
      this.instructor.provisional !== 'Yes' && 
      (this.instructor.classroom_instructor === 'Yes' ||
      this.instructor.behind_the_wheel === 'Yes')
    ) {
      certExpColsTopMargin = 16;
    }

    // No provisional AND CR AND BTW
    if ( 
      this.instructor.provisional !== 'Yes' && 
      (this.instructor.classroom_instructor === 'Yes' &&
      this.instructor.behind_the_wheel === 'Yes')
    ) {
      certExpColsTopMargin = 6;
    } 

    var certExpCols = {
      columns: [
        { width: '55%', text: [
          { text: 'Certificate Registry No: ', fontSize: 9 },
          { text: ( '0000' + this.instructor.registry_number ).slice(-4), bold: true, fontSize: 10 }
        ]},
        { width: '45%', text: [
          { text: 'Exp. Date: ', fontSize: 9 },
          { text: moment(this.instructor.certifications[0].date_expire).format('MM/DD/YYYY'), bold: true, fontSize: 10 }
        ]},
      ],
      margin: [10, certExpColsTopMargin, 0, 0]
    }

    docContent.push( certExpCols );

    this.dd = {
      content: docContent,
      // Cards are 2 1/8 x 3 3/8 (153 x 243)
      pageSize: { width: 243, height: 153 },
      pageOrientation: 'landscape',
      pageMargins: [ 0, 0, 0, 0 ],
      background: [{
        image: this.imageService.certificateCardBg(),
        width: 243
      }]
    }

    let fileName = this.instructor.first_name + '_' + this.instructor.last_name + '_Approved_Instructor_Certificate.pdf';
    pdfMake.createPdf( this.dd ).download( fileName );
    loader.dismiss();
  }

  presentMakeRegistryNumberEditableActionSheet()
  {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'TAKE A STEP BACK! Are you sure you want to edit the Registry Number?',
      buttons: [
        {
          text: 'Yes, I need to edit the registry number.',
          role: 'destructive',
          handler: () => {
            this.makeRegistryNumberEditable();
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {}
        }
      ]
    });

    actionSheet.present();
  }

  makeRegistryNumberEditable()
  {
    this.isRegistryNumberDisabled = false;
  }

  sendPortalLink()
  {
    this.instructorsService.sendPortalLink( this.instructor.instructor_id )
      .subscribe( data => {
        this.events.publish('app:log', {
          message: 'Instructor portal link has been sent.',
          status: 'success',
          type: 'send portal link'
        });
      });
  }

  viewPortal()
  {
    this.instructorsService.getPortalLink( this.instructor.instructor_id, this.instructor.registry_number, this.instructor.guid )
      .subscribe( data => {
        let d:any = data;
        window.open( d.access_url, '_blank' );
      });
  }

  resendPassCourseCertificateEmail()
  {
    console.log('sending cert');
    this.instructorsService.sendPassCourseCertificate( this.instructor.instructor_id )
      .subscribe( data => {
        this.events.publish('app:log', {
          message: 'Pass Course Certificate email has been sent.',
          status: 'success',
          type: 'resend certificate email'
        });
      });
  }

  clearDateOnUncheck( ev, type )
  {
    if ( !ev.checked )
    {
      switch ( type )
      {        
        case 'ars':
          this.instructor.ars_date_entered = '0001-01-01';
          break;
        case 'first-aid':
          this.instructor.first_aid_card_expire = '0001-01-01';
          break;
        case 'cpr-card':
          this.instructor.cpr_card_expire = '0001-01-01';
          break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/instructors/instructor-add-edit.ts